import styles from "./Contact.module.css";

export default function HeroSection() {
  return (
    <div className={styles.heroSection}>
      <h1 className={styles.heroTitle}>Get in Touch</h1>
      <p className={styles.heroDescription}>
        We're here to help. Reach out to us with questions, suggestions, or to
        learn more about how you can support Mississippi's roadworkers.
      </p>
    </div>
  );
}
